import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

export const adminHeader = () => {
  const pw = localStorage.getItem("kk_admin_pw");
  return pw ? { "X-Admin-Password": pw } : {};
};

export const ApiClient = {
  getConfig: () => api.get("/config").then((r) => r.data),
  corebridgeHealth: () => api.get("/health/corebridge").then((r) => r.data),
  sessionValidate: (launch_token) =>
    api.post("/session/validate", { launch_token }).then((r) => r.data),
  demoLaunch: (payload) =>
    api.post("/session/demo-launch", payload).then((r) => r.data),
  gameLaunch: (payload) =>
    api.post("/game/launch", payload).then((r) => r.data),
  balance: (player_id, currency) =>
    api
      .get("/player/balance", { params: { player_id, currency } })
      .then((r) => r.data),
  play: (payload) => api.post("/round/play", payload).then((r) => r.data),
  history: (limit = 25) =>
    api.get(`/round/history`, { params: { limit } }).then((r) => r.data),

  // admin
  adminLogin: (password) =>
    api.post("/admin/login", { password }).then((r) => r.data),
  adminLastTxns: () =>
    api.get("/admin/last-txns", { headers: adminHeader() }).then((r) => r.data),
  adminGetMode: () =>
    api.get("/admin/mode", { headers: adminHeader() }).then((r) => r.data),
  adminSetMode: (mode) =>
    api
      .post("/admin/mode", { mode }, { headers: adminHeader() })
      .then((r) => r.data),
  adminGetFlags: () =>
    api
      .get("/admin/sim-flags", { headers: adminHeader() })
      .then((r) => r.data),
  adminSetFlag: (name, value) =>
    api
      .post("/admin/sim-flags", { name, value }, { headers: adminHeader() })
      .then((r) => r.data),
  adminResetFlags: () =>
    api
      .post("/admin/sim-flags/reset", null, { headers: adminHeader() })
      .then((r) => r.data),
  adminReplayDebit: () =>
    api
      .post("/admin/replay/debit", null, { headers: adminHeader() })
      .then((r) => r.data),
  adminReplayCredit: () =>
    api
      .post("/admin/replay/credit", null, { headers: adminHeader() })
      .then((r) => r.data),
  adminRollbackDebit: () =>
    api
      .post("/admin/rollback/debit", null, { headers: adminHeader() })
      .then((r) => r.data),
  adminRollbackCredit: () =>
    api
      .post("/admin/rollback/credit", null, { headers: adminHeader() })
      .then((r) => r.data),
  adminRollbackById: (parent_txn_id) =>
    api
      .post(
        "/admin/rollback/by-id",
        { parent_txn_id },
        { headers: adminHeader() }
      )
      .then((r) => r.data),
  adminStress: (payload) =>
    api
      .post("/admin/stress", payload, { headers: adminHeader() })
      .then((r) => r.data),
  certificationRun: (player_id, currency, bet_amount = 50) =>
    api
      .post(
        "/certification/run",
        null,
        {
          params: { player_id, currency, bet_amount },
          headers: adminHeader(),
        }
      )
      .then((r) => r.data),
};

export const fmtCurrency = (amount, currency) => {
  if (amount === null || amount === undefined || Number.isNaN(Number(amount)))
    return "—";
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currency || "USD",
      maximumFractionDigits: 2,
    }).format(Number(amount));
  } catch {
    return `${currency || ""} ${Number(amount).toFixed(2)}`;
  }
};

export const shortId = (s, head = 10, tail = 6) => {
  if (!s) return "—";
  return s.length <= head + tail + 1 ? s : `${s.slice(0, head)}…${s.slice(-tail)}`;
};

export default ApiClient;
